import React, { useEffect, useState } from 'react'
import MeetingTab from './MeetingTab'
import { useParams } from 'react-router-dom';
import { useGetLogspaginationQuery } from 'src/services/ContactServices';

const MeetingTabWrapper = () => { 
    const { contactId } = useParams();
    const [meetingsData, setMeetingsData] = useState<any>();
  
    const { data, isLoading, isFetching } = useGetLogspaginationQuery({
      limit: 10,
      searchValue: "",
      params: ["description"],
      page: 0,
      filterBy: [
        {
          fieldName: "contactId",
          value: [contactId || ""],
        },
        {
          fieldName: "logType",
          value: ["MEETING"],
        },
      ],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: false,
    });
  
    useEffect(() => {
      if (!isLoading && !isFetching) {
        setMeetingsData(data?.data);
      }
    }, [data, isLoading, isFetching]);
  return (
   <MeetingTab isLoading={isLoading || isFetching} meetingsData={meetingsData}/>
  )
}

export default MeetingTabWrapper